export default __webpack_public_path__ + "static/media/ArdashirCity.e61b81de.jpg";